export default "__VITE_ASSET__DGKf$wIX__"